import { FadeInUp } from '../components/animations';
import SEO from '../components/SEO';
import { breadcrumbSchema } from '../utils/schema';
import SupplierBenefits from '../components/suppliers/SupplierBenefits';
import SupplierRegistrationForm from '../components/suppliers/SupplierRegistrationForm';

const ForSuppliersPage = () => (
  <div className="pt-20" data-testid="for-suppliers-page">
    <SEO
      title="For Suppliers | Register as an Indian Manufacturer | Taiga Sourcing"
      description="Indian manufacturers — register with Taiga Sourcing to connect with international buyer requirements across multiple product categories."
      keywords="register as supplier India, Indian manufacturer registration, connect with buyers India"
      path="/for-suppliers"
      schema={breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'For Suppliers', path: '/for-suppliers' }])}
    />
    <section className="relative py-24 lg:py-32 bg-[#071E45] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <FadeInUp>
          <p className="text-sm tracking-[0.3em] uppercase text-white/50 mb-4 font-medium">For Manufacturers</p>
          <h1
            className="text-4xl sm:text-5xl font-bold tracking-tight leading-[1.1] mb-6"
            style={{ fontFamily: 'Cabinet Grotesk' }}
            data-testid="suppliers-title"
          >
            JOIN THE TAIGA SOURCING NETWORK.
          </h1>
          <p className="text-base text-white/70 leading-relaxed max-w-3xl mx-auto">
            We work with Indian manufacturers across multiple categories and connect suitable capabilities with international buyer requirements.
          </p>
        </FadeInUp>
      </div>
    </section>

    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <FadeInUp>
            <SupplierBenefits />
          </FadeInUp>
          <FadeInUp delay={0.2}>
            <SupplierRegistrationForm />
          </FadeInUp>
        </div>
      </div>
    </section>
  </div>
);

export default ForSuppliersPage;
